<script lang="ts">
  import { M1 } from '../modules';

  export let volume: number = 0.5;

  let filledChar = '█';
  let emptyChar = '░';
  const VOLUME_BAR_SEGMENTS = 19;
  let total = VOLUME_BAR_SEGMENTS;

  $: filled = Math.round(volume * total);
  $: empty = total - filled;
  $: pct = Math.round(volume * 100);

  function onSliderInput(e: Event) {
    const newVol = parseFloat((e.target as HTMLInputElement).value);
    volume = newVol;
    M1?.setVolume?.(newVol);
  }

  function onWheel(e: WheelEvent) {
    e.preventDefault();
    const delta = e.deltaY > 0 ? -0.05 : 0.05;
    const newVol = Math.max(0, Math.min(1, volume + delta));
    volume = newVol;
    M1?.setVolume?.(newVol);
  }
</script>

<div id="volume-row" on:wheel={onWheel}>
  <div id="volume-stack">
    <div id="volume-bar">
      <span>{filledChar.repeat(filled)}</span>
      <span class="empty">{emptyChar.repeat(empty)}</span>
    </div>
    <input
      type="range"
      id="volume-slider"
      min="0"
      max="1"
      step="0.01"
      value={volume}
      on:input={onSliderInput}
      aria-label="Volume"
      aria-valuetext={pct + '% volume'}
    />
  </div>
  <span id="volume-readout">{pct}%</span>
</div>
